import React, {useState} from 'react'
import * as bootstrap from 'bootstrap';
import $ from "jquery";
import apiService from '../services/api';

function Login(props){
    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    
    // Kiểm tra thông tin đã lưu khi component mount
    React.useEffect(() => {
        const savedUsername = localStorage.getItem('adminUsername');
        if(savedUsername) {
            setUser(savedUsername);
            setRememberMe(true);
        }
    }, []);
    
    async function handleSubmit(e){
        e.preventDefault();
        try {
            setLoading(true);
            $("#loginBtn")[0].innerHTML = "Đang đăng nhập...";
            
            const credentials = {
                username: user,
                password: pass
            };
            
            const response = await apiService.authenticateAdmin(credentials);

            if(response.success){
                // Lưu thông tin đăng nhập vào sessionStorage
                sessionStorage.setItem('isAuthenticated', 'true');
                sessionStorage.setItem('user', JSON.stringify(response.user));
                
                // Nếu checkbox "Ghi nhớ" được check, chỉ lưu username
                if(rememberMe) {
                    localStorage.setItem('adminUsername', user);
                } else {
                    // Nếu không check "Ghi nhớ", xóa thông tin đã lưu
                    localStorage.removeItem('adminUsername');
                }
                
                // Reload trang để cập nhật UI
                window.location.reload();
            } else {
                // Hiển thị lỗi
                showLoginError();
            }
        } catch (error) {
            console.error('Login error:', error);
            showLoginError();
        } finally {
            setLoading(false);
        }
    }

    function showLoginError() {
        $("#loginBtn")[0].innerHTML = `Đăng nhập`;
        var trigger = document.getElementById('falseLoginToast');
        var toast = new bootstrap.Toast(trigger);
        // Chỉ clear password, giữ lại username nếu có "Ghi nhớ"
        if(!rememberMe) {
            setUser("");
        }
        setPass("");
        toast.show();
    }

    return(
        <>
            <div className="t-center text-center bg-hunghau">
                <div className="form-signin">
                    <form onSubmit={handleSubmit}>
                        <img className="mb-3" src="https://vhu.edu.vn/Resources/Images/SubDomain/HomePage/Logo/logo-footer.png" alt="" width="150" />
                        <h1 className="mb-3"><b>Đăng nhập</b></h1>

                        <div className="form-floating mb-2">
                            <input type="text" className="form-control" id="ftun" placeholder="Tài khoản" required value={user} onChange={(e) => setUser(e.target.value)} />
                            <label htmlFor="ftun" style={{"color": "black"}}>Tài khoản</label>
                        </div>
                        <div className="form-floating mb-3">
                            <input type="password" className="form-control" id="flpw" placeholder="Mật khẩu" required value={pass} onChange={(e) => setPass(e.target.value)}/>
                            <label htmlFor="flpw" style={{"color": "black"}}>Mật khẩu</label>
                        </div>
                        <div className="checkbox mb-3">
                            <label>
                                <input 
                                    type="checkbox" 
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                /> Ghi nhớ đăng nhập
                            </label>
                        </div>
                        <button className="w-100 btn btn-lg btn-primary" id="loginBtn" type="submit" disabled={loading}>
                            {loading ? "Đang đăng nhập..." : "Đăng nhập"}
                        </button>
                        <p className="mt-5">Copyright {new Date().getFullYear()} &copy; <b>VanHien University</b></p>
                    </form>
                    <div className="toast-container position-fixed top-0 end-0 p-3" id="notifications" style={{"zIndex": "11"}}>
                        <div id="falseLoginToast" className="toast" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header">
                                <img src="https://vhu.edu.vn/Resources/Images/SubDomain/HomePage/Logo/logo-footer.png" className="rounded me-2" alt="..." style={{"height":"25px"}} />
                                <strong className="me-auto">Lỗi đăng nhập</strong>
                                <small>Vài giây trước</small>
                                <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                            </div>
                            <div className="toast-body bg-primary">
                                Sai tài khoản hoặc mật khẩu, vui lòng kiểm tra lại!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;